export default __webpack_public_path__ + "static/media/NCB.49c4d8e6.png";